<template>
  <div class="pointer-events-none animate-pulse">
    <div v-for="index in 9" :key="index" class="flex items-center space-x-3 py-2 pl-2 pr-4">
      <CheckBox disabled />
      <span class="bg-neutral-95 h-3 w-full rounded-sm" />
    </div>
  </div>
</template>

<script lang="ts" setup>
// Components
import CheckBox from "@atoms/CheckBox.vue";
</script>
